export const featuredProjects = [
  {
    slug: "eze-logs",
    title: "eZe Logs - Fleet Management System",
    shortDescription: "Real-time fleet tracking and compliance management platform",
    photo: "/assets/imgs/works/2.png",
    category: "Web Application",
    
    problem: "Transportation companies struggled with manual driver compliance tracking, leading to regulatory violations and inefficient fleet management.",
    
    myRole: "Full-Stack Engineer",
    
    technologies: [
      "Laravel 10", 
      "REST API", 
      "MySQL", 
      "React.js", 
      "Redis Cache",
      "JWT Authentication"
    ],
    
    responsibilities: [
      "Designed and developed RESTful APIs for real-time vehicle tracking",
      "Implemented role-based access control (RBAC) for drivers, managers, and admins",
      "Optimized database queries reducing response time by 60%",
      "Integrated third-party GPS and compliance APIs"
    ],
    
    outcome: {
      metric1: "60% faster data retrieval",
      metric2: "1000+ daily active users",
      metric3: "99.9% API uptime"
    },
    
    link: null
  },
  
  {
    slug: "dubai-fashion-week",
    title: "Dubai Fashion Week - Event Management Platform",
    shortDescription: "Comprehensive event booking and management system",
    photo: "/assets/imgs/works/1.png",
    category: "E-Commerce & Booking",
    
    problem: "Fashion event organizers needed an automated system to handle designer registrations, ticket sales, and schedule management.",
    
    myRole: "Backend Developer & API Architect",
    
    technologies: [
      "Laravel 9",
      "MySQL",
      "Stripe API",
      "Email Automation",
      "Laravel Queue",
      "Bootstrap"
    ],
    
    responsibilities: [
      "Built secure payment processing with Stripe integration",
      "Developed automated email notification system for bookings",
      "Created admin dashboard for event and attendee management",
      "Implemented multi-vendor registration system"
    ],
    
    outcome: {
      metric1: "500+ designer registrations",
      metric2: "3000+ tickets sold",
      metric3: "$50K+ processed securely"
    },
    
    link: null
  },
  
  {
    slug: "bright-vision-health",
    title: "Bright Vision Health - Patient Management System",
    shortDescription: "HIPAA-compliant healthcare management platform",
    photo: "/assets/imgs/works/4.png",
    category: "Healthcare SaaS",
    
    problem: "Healthcare providers needed a secure, compliant system to manage patient records, appointments, and billing.",
    
    myRole: "Full-Stack Developer",
    
    technologies: [
      "Laravel 10",
      "MySQL",
      "AES-256 Encryption",
      "REST API",
      "Two-Factor Auth",
      "Chart.js"
    ],
    
    responsibilities: [
      "Implemented end-to-end encryption for patient data (HIPAA compliant)",
      "Built appointment scheduling API with conflict detection",
      "Created billing module with insurance claim tracking",
      "Designed responsive patient portal"
    ],
    
    outcome: {
      metric1: "200+ providers onboarded",
      metric2: "5000+ patient records secured",
      metric3: "Zero security incidents"
    },
    
    link: null
  },
  
  {
    slug: "shl-london",
    title: "SHL London - Corporate Training Platform",
    shortDescription: "Learning management system for corporate training",
    photo: "/assets/imgs/works/3.png",
    category: "EdTech Platform",
    
    problem: "Corporate training required a centralized platform for course management, progress tracking, and certification issuance.",
    
    myRole: "Full-Stack Developer",
    
    technologies: [
      "Laravel 9",
      "MySQL",
      "Vue.js",
      "REST API",
      "AWS S3",
      "PDF Generation"
    ],
    
    responsibilities: [
      "Developed course management system with video streaming",
      "Built progress tracking and analytics dashboard",
      "Implemented automated certificate generation",
      "Created interactive quiz and assessment modules"
    ],
    
    outcome: {
      metric1: "50+ courses hosted",
      metric2: "2000+ trainees enrolled",
      metric3: "95% completion rate"
    },
    
    link: null
  }
];

